import { JwtTokens } from '@wizbii-utils/angular/jwt';
import { CookieService } from 'ngx-cookie-service';

export const COOKIE_NAME = 'wizbii_tokens';
export const EXPIRY_COOKIE_NAME = 'wizbii_tokens_expiry';

export function writeWizbiiTokensInCookie(
  cookieService: CookieService,
  tokens: JwtTokens,
  {
    defaultCookieDomain,
    cookieDomains,
    platform,
    appId,
    locale,
  }: {
    defaultCookieDomain?: string;
    platform: string;
    cookieDomains: Record<string, string>;
    locale: string;
    appId: string;
  }
): void {
  const cookieDomain =
    defaultCookieDomain ?? appId === 'jobs' ? cookieDomains['fr_FR'] : cookieDomains[locale] ?? 'wizbii.me';
  const domainCookie =
    cookieDomain === 'localhost' ? cookieDomain : cookieDomain.startsWith('.') ? cookieDomain : `.${cookieDomain}`;
  const msIn390Days = 1000 * 3600 * 24 * 390;
  const expiry = new Date(Date.now() + msIn390Days).getTime();
  const isSecure = platform !== 'local';
  const sameSite = platform === 'local' ? 'Lax' : 'None';

  cookieService.set(COOKIE_NAME, JSON.stringify(tokens), expiry, '/', domainCookie, isSecure, sameSite);
  cookieService.set(EXPIRY_COOKIE_NAME, expiry.toString(10), expiry, '/', domainCookie, isSecure, sameSite);
}

export function deleteWizbiiCookieTokens(
  cookieService: CookieService,
  {
    defaultCookieDomain,
    cookieDomains,
    platform,
    locale,
  }: {
    defaultCookieDomain?: string;
    platform: string;
    cookieDomains: Record<string, string>;
    locale: string;
  }
): void {
  const cookieDomain = defaultCookieDomain ?? cookieDomains[locale] ?? 'wizbii.me';
  const domainCookie =
    cookieDomain === 'localhost' ? cookieDomain : cookieDomain.startsWith('.') ? cookieDomain : `.${cookieDomain}`;
  const isSecure = platform !== 'local';
  const sameSite = platform === 'local' ? 'Lax' : 'None';
  const forgetDate = new Date('Thu, 01 Jan 1970 00:00:01 GMT');

  cookieService.set(COOKIE_NAME, '', forgetDate, '/', domainCookie, isSecure, sameSite);
  cookieService.set(EXPIRY_COOKIE_NAME, '', forgetDate, '/', domainCookie, isSecure, sameSite);
}
